module.exports = __webpack_public_path__ + "media/images/payment/paypal-9abffe0e8adbd1b1f9221eba75e2f410.svg";